import { type UseQueryResult, useQuery } from 'react-query';
import { SupportContactService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetAlertTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const alertTypes = useQuery(
    ['getAlertTypes'],
    async () => {
      return await handleRequest(
        SupportContactService.getApiCustomerApiAppSupportContactActiveAlertSubscriptionTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.value ?? '',
          };
        });
      },
      cacheTime: 1000 * 60 * 5,
    }
  );

  return alertTypes;
};

export default useGetAlertTypes;
